import {GMN_PATH} from '../../../common/commonConst.js';
/**
 * @typedef MinorItem 小項目単位の型
 * @property {string} name メニュー項目名
 * @property {string} [path] 遷移先
 */

/**
 * @typedef MiddleItem 中項目単位の型
 * @property {string} name メニュー項目名
 * @property {function[]} [conditions] 項目表示判定function
 * @property {MinorItem[]} items 小項目の一覧
 */

/**
 * @typedef MajorItem 大項目単位の型
 * @property {string} name メニュー項目名
 * @property {function[]} [conditions] 項目表示判定function
 * @property {MiddleItem[]} items 中項目の一覧
 * @property {function} [action] クリック時実行処理。指定時pathは使用しない
 * @property {string} [path] 遷移先
 */

/**
 * メニュー項目定義
 * @type {{[id:number]: MajorItem[]}}
 * */
const MENU_ITEMS = [
  {
    name: 'お客さま情報照会',
    items: [
      {gamenId: 'SCZ1008', name: 'お客さま情報照会', path: GMN_PATH.CUSTOMER_INFO_LIST},
    ],
  },
  {
    name: '調査・点検対象管理',
    items: [
      {gamenId: 'SCI1001', name: '調査年度・委託エリア管理', path: GMN_PATH.SURVEY_YEAR_COMPANY_LIST},
      {gamenId: 'SCA1001', name: '調査業種管理', path: GMN_PATH.SURVEY_INDUSTRY_LIST},
      {gamenId: 'SCB1001', name: '翌年度再調査管理', path: GMN_PATH.SURVEY_REASON_LIST},
      {gamenId: 'SCA1011', name: '毎年調査お客さま全使撤リスト一覧', path: GMN_PATH.ZENSITETU_LIST},
      {gamenId: 'SCA1014', name: '毎年調査お客さま全使撤リスト(調査機関用)', path: GMN_PATH.ZENSITETU_ITAKU_LIST},
    ],
  },
  {
    name: '交付設定',
    items: [
      {gamenId: 'SCC1001', name: '目標調査件数設定', path: GMN_PATH.GOAL_INVEST_SETTING_LIST},
      {gamenId: 'SCC1003', name: '調査・点検機関設定', path: GMN_PATH.ITAKU_SETTING_LIST},
      {gamenId: 'SCC1002', name: '委託エリア設定', path: GMN_PATH.GOAL_INVEST_SETTING_MESH},
      {gamenId: 'SCC1004', name: '調査・点検口数(予定)一覧', path: GMN_PATH.ITAKU_TSTK_GUTISU_LIST},
      {gamenId: 'SCD1002', name: '調査・点検箇所追加交付', path: GMN_PATH.TSTK_KASYO_MANAGE_LIST},
    ],
  },
  {
    name: '年度計画策定',
    items: [
      {gamenId: 'SCD1001', name: '調査口数一覧', path: GMN_PATH.SURVEY_POPULATION_LIST},
      {gamenId: 'SCE1001', name: '年度計画登録', path: GMN_PATH.ANNUAL_SURVERY_PLAN_LIST},
    ],
  },
  {
    name: '調査・点検実施',
    items: [
      {gamenId: 'SCF1001', name: '調査・点検箇所一覧', path: GMN_PATH.TSTK_KASYO_LIST},
      {gamenId: 'SCF1007', name: '調査・点検結果報告(調査機関用)', path: GMN_PATH.TSTK_RESULT_REPORT_LIST},
      {gamenId: 'SCF1009-01', name: '調査・点検結果報告(NWC用)', path: GMN_PATH.TSTK_PROGRESS_BLOCK_REPORT_LIST},
      {gamenId: 'SCG1001', name: '調査・点検結果確認', path: GMN_PATH.TSTK_RESULT_CONFIRM_LIST},
      {gamenId: 'SCF1009', name: '調査・点検進捗状況照会(ブロック別)', path: GMN_PATH.TSTK_PROGRESS_BLOCK_LIST},
      {gamenId: 'SCF1008', name: '調査・点検進捗状況照会(月別・工程別)', path: GMN_PATH.TSTK_PROGRESS_MONTH_KOTEI_LIST},
      {gamenId: 'SCH1001', name: '調査・点検実績確認', path: GMN_PATH.TSTK_ACTUAL_CONFIRM_LIST},
      {gamenId: 'SCH1002', name: '調査・点検対象集計', path: GMN_PATH.ITAKU_TSTK_GUTISU_SK_LIST},
    ],
  },
  {
    name: '承認一覧',
    items: [
      {gamenId: 'SCZ1005', name: '承認一覧', path: GMN_PATH.APPLICATION_APPROVAL_LIST},
    ],
  },
  {
    name: 'その他',
    items: [
      {gamenId: 'SCZ1003', name: 'ユーザ一覧', path: GMN_PATH.USER_MASTER_LIST},
      {gamenId: 'SCZ1007', name: 'ログ検索', path: GMN_PATH.LOGSEARCH_LIST},
      {gamenId: 'SCZ1011', name: 'ファイル管理', path: GMN_PATH.FILE_MNG_LIST},
      {gamenId: 'SCZ1010', name: 'システム設定', path: GMN_PATH.SYSTEM_SETTING},
      {gamenId: 'SCY1001', name: '定期調査実施状況', path: GMN_PATH.TSTK_IMPLEMENT_STATUS_LIST},
      {gamenId: 'SCY1002', name: 'お客さま個別管理', path: GMN_PATH.CUSTOMER_INDIVIDUAL_MANAGE_LIST},
      {gamenId: 'SCY1004', name: '屋内線定期調査集計', path: GMN_PATH.TK_INVESTIGATION_TOTAL_LIST},
    ],
  },
];

/**
 * メニュー項目の取得。
 *
 * @param {object} userInfo ユーザ情報
 * @param {object} roleMenuItems 権限別メニュー項目
 * @return {MajorItem[]} メニュー大項目一覧
 */
export default function getMenuItems(userInfo, roleMenuItems) {
  console.log('getMenuItems');
  // 未ログイン時はメニューを返却しない
  if (!userInfo || !roleMenuItems) {
    return [];
  }

  console.dir(userInfo);

  const menuItems = MENU_ITEMS.map((list) => ({...list}));

  const topMenuItems = roleMenuItems.filter((item) => item.superGamenId == null || item.superGamenId == '');
  const topGamenIds = new Set(topMenuItems.map((item) => item.gamenId));
  // 権限別メニューをよって、画面に表示するメニューを取得する
  const filteredMenuItems = menuItems
      .map((menuItem) => ({
        ...menuItem,
        items: menuItem.items.filter((item) => topGamenIds.has(item.gamenId)),
      }))
      .filter((menuItem) => menuItem.items.length > 0);

  return filteredMenuItems;
}
